import qs from "qs";
import { reverseFacetCategoryMap } from "./facetCategoryMap";
import { sanitizeString } from "./sanitizeString";

/**
 * urlToSearchState() - takes the URL of the search and formats it into an object that Algolia can use to keep the query, filters and sort persisting
 * @param {object} location - object that is destructured to so we get the search query params
 * @param {string} indexName - name of the search index for sort values
 * @returns {object} searchState
 */
 export const urlToSearchState = ({ search }, sortList = []) => {
  let searchState = {};
  const searchObject = qs.parse(search);

  for (const [key, value] of Object.entries(searchObject)) {
    if (key === "?search") {
      searchState.query = sanitizeString(value);
    }
    // reverse lookup the facet category map
    if (reverseFacetCategoryMap[key]) {
      searchState.refinementList = { 
        ...searchState.refinementList,
        // change value back into an array
        [reverseFacetCategoryMap[key]]: sanitizeString(value).split(',')
      };
    }
    if (key === "sort") {
      const sortValue = sortList?.find(({id}) => id === value)?.value || "";
      searchState.sortBy = sanitizeString(sortValue);
    }
  }
  return searchState;
};